export const MODULE_ADDRESS = "0xec714c0618845f5033b9d6f1bd9d32b6a00ab611e38738a3073a118a37d61a5c";
export const RESOURCE_ADDRESS = "0x24cca4b277151d5655efbcb1b6912f4b40b06132530e60c62e26a68a0d0a5233";

// Geomi No-Code Indexer — all token events (created, graduated, purchase, sale)
export const GEOMI_GRAPHQL_ENDPOINT = "https://api.testnet.aptoslabs.com/nocode/v1/api/cmhtiqv8w005ps601yfd1g4ur/v1/graphql";
export const GEOMI_API_KEY = process.env.REACT_APP_GEOMI_API_KEY || "";